module.exports = __webpack_public_path__ + "img/bp.d3e10aae.png";